/**
 * created by li si yi
 * 内容安全中心部门树
 */
import React from "react";
import BaseComponent from "../../../base/BaseComponent";
import {generateTreeData, treeForEach, uuid} from "../../../utils";
import {Icon, TreeSelect} from "antd";
import site from "../../mediaRelease/websiteManage/images/site.png";

const {TreeNode} = TreeSelect;
export default class DeptTree extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            defaultParams: {
                page: 1,
                size: 10,
                keywords: "",
                startTime: "",
                endTime: "",
                treeContentId: ""
            },
            treeData: [],
            treeDataIndex: {
                id: "id",
                title: "name",
                children: "child",
                key: "id"
            },
        };
    }

    componentDidMount() {
        this.deptGetTree();
    }

    deptGetTree = () => {
        this.deptGetTreeRequest(res => {
            // 格式化树数据
            const treeData = generateTreeData([res], this.state.treeDataIndex);
            this.setState({
                treeData
            });
        });
    };
    deptGetTreeRequest = (callBack) => {
        this.request({
            url: "/cm-sites-sys/dept/getTree",
            body: {id: 0},
            callBack
        });
    };

    render() {
        return (
            <>
                {this.renderTree()}
            </>
        );
    }

    renderTree = () => {
        const itemIcon = <img src={site}/>;
        const itemIcon2 = <Icon type="file-text"/>;
        const ExpandedIcon = <Icon style={{color: "#ffcd2c"}} type="folder-open" theme="filled"/>;
        const ClosedIcon = <Icon style={{color: "#ffcd2c"}} type="folder" theme="filled"/>;
        const columnLoop = (data) => {
            return data.map(item => {
                let TitleIcon;
                if (item.children && item.children.length) {
                    if (this.state.defaultParams.treeContentId === item.id) {
                        TitleIcon = ExpandedIcon;
                    } else {
                        TitleIcon = ClosedIcon;
                    }
                } else {
                    TitleIcon = itemIcon2;
                }
                // 最终的展示 title
                let title = <div style={{display: "flex"}}>
                    <div>{TitleIcon}</div>
                    <div title={item.title} style={{
                        marginLeft: "8px",
                        width: 120,
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                    }}>{item.title}</div>
                </div>;
                return <TreeNode value={item.title} title={title} key={item.id}>
                    {item.children && item.children.length ? columnLoop(item.children) : ""}
                </TreeNode>;
            });
        };
        return (
            <div style={{ marginRight: 24}}>
                <div style={{width: "100%", maxWidth: "224px"}} key={uuid()}>
                    <TreeSelect
                        showSearch={true}
                        style={{width: "100%"}}
                        // disabled={this.props.disabled}
                        allowClear
                        placeholder={"请选择单位名称"}
                        dropdownStyle={{maxHeight: 250, width: 224}}
                        multiple={false}
                        treeDefaultExpandAll
                        searchPlaceholder={"请输入关键词"}
                        value={this.state.defaultParams.treeContentId ? this.state.defaultParams.treeContentId : undefined}
                        onChange={(value, label, extra) => {
                            if (value === null) return;
                            this.state.defaultParams.treeContentId = value;
                            let deptValue = value;
                            let deptId = extra && extra.triggerNode && extra.triggerNode.props && extra.triggerNode.props.eventKey;
                            console.log(deptValue, deptId);
                            if (!deptValue) {
                                deptValue = "";
                            }
                            // 父页面回调
                            this.props.deptIdsCall && this.props.deptIdsCall(deptValue, deptId);
                            this.setState({});
                        }}
                    >
                        {columnLoop(this.state.treeData)}
                    </TreeSelect></div>
            </div>
        )
    };
    refresh = () => {
        this.state.defaultParams.treeContentId = ""
        this.setState({})
    }
}
